import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ContainerHeader from '../../components/ContainerHeader/ContainerHeader';
import { Stylesheet } from '../../interfaces/Stylesheet';
import style from './Customer.module.scss';

interface CustomerHeaderProps {
  allowCancelling: boolean;
  stylesheet: Stylesheet;
}

const CustomerHeader: FC<CustomerHeaderProps> = ({ stylesheet }) => {
  const { t } = useTranslation();

  return (
    <ContainerHeader
      containerHeaderClassName={style.customerHeader}
      text={stylesheet.customerSection.leadBlock.value}
      title={t('customerSection:title', { partner: stylesheet.settings.partnerName })}
    />
  );
};

export default CustomerHeader;
